import { render } from "./CtaHabientes.vue?vue&type=template&id=6cab235e&scoped=true"
import script from "./CtaHabientes.vue?vue&type=script&lang=js"
export * from "./CtaHabientes.vue?vue&type=script&lang=js"

import "./CtaHabientes.vue?vue&type=style&index=0&id=6cab235e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cab235e"]])

export default __exports__